export enum lang {
  en = 'en'
}
